export default __webpack_public_path__ + "static/media/487_06-18-2022_Jennifer+Jack_Wedding_tn.3fa250cc.jpg";